$(function () {
  const slideshow = $('.js-slideshow').hide()
  const slider = slideshow.find('.js-slider')
  const btn = $('.js-btn-slideshow')
  const chambre = $('.js-btn-chambre')
  const close = slideshow.find('.js-btn-close-slideshow')

  const openSlideshow = function () {
    slider.show()
    slider.slick({
      prevArrow: '<div class="arrows prev"></div>',
      nextArrow: '<div class="arrows next"></div>'
    })

    let slidenumber = $(this).data('position')
    if (slidenumber) {
      slider.slick('slickGoTo', slidenumber)
    }

    $('body').addClass('stop-scrolling')
    slideshow.css({
      height: $(window).height(),
      top: $(document).scrollTop()
    }).fadeIn()
  }

  const closeSlideshow = function () {
    slideshow.fadeOut(500, function () {
      slider.slick('unslick');
      slider.hide()
    })
    $('body').removeClass('stop-scrolling')
  }

  const init = function () {
    slideshow.find('img').each(function () {
      /*$(this).css({
        height: $(window).height() < $(window).width() ? `${$(window).height() - 300}px` : 'auto',
        width: $(window).height() > $(window).width() ? `${$(window).width()}px` : 'auto'
      })*/
    })
  }



  init()

  // BINDINGS
  btn.on('click', openSlideshow)
  chambre.on('click', openSlideshow)
  close.on('click', closeSlideshow)
  window.addEventListener('resize', init)
  document.onkeydown = function(evt) {
    if (!slider.slick) return
    evt = evt || window.event;
    switch (evt.keyCode) {
        case 37:
            slider.slick('slickPrev')
            break;
        case 39:
            slider.slick('slickNext')
            break;
    }
  };
});
